export class LoadFinOpsAzureServicesHistoricalData {
    static type = '[FINOPS][AZURE][SERVICES] LoadFinOpsAzureServicesHistoricalData'
}

export class LoadDataTableAllSubscriptionsFinOpsAzureServices {
    static type = '[FINOPS][AZURE][SERVICES] LoadDataTableAllSubscriptionsFinOpsAzureServices'
}

export class LoadFinOpsAzureServicesChartsData {
    static type = '[FINOPS][AZURE][SERVICES] LoadFinOpsAzureServicesChartsData'
}

export class LoadFinOpsAzureServicesAllSubscriptionsChartsFilteredData {
    static type = '[FINOPS][AZURE][SERVICES] LoadFinOpsAzureServicesAllSubscriptionsChartsFilteredData'
}
